import React, { useState, useEffect, useRef } from 'react';
import { Award, Users, Heart, Star } from 'lucide-react';
import './StatsSection.css';

const Counter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.5 }
    );
    if (countRef.current) observer.observe(countRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    // Kanka noktaları temizliyoruz ki sayı düzgün artsın
    const endValue = parseInt(end.toString().replace(/\./g, ''));
    const totalMiliseconds = duration;
    const increment = endValue / (totalMiliseconds / 16);
    
    const timer = setInterval(() => {
      start += increment;
      if (start >= endValue) {
        setCount(endValue);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, end, duration]);

  // Sayıyı ekrana basarken tekrar binlik ayracı (nokta) ekliyoruz
  return <span ref={countRef}>{count.toLocaleString('tr-TR')}</span>;
};

const StatsSection = () => {
  const stats = [
    { id: 1, icon: <Users size={28} />, end: "50000", suffix: "+", label: "Mutlu Çocuk", color: "#4FBDBA" },
    { id: 2, icon: <Award size={28} />, end: "30", suffix: "+", label: "Yıllık Tecrübe", color: "#FFB347" },
    { id: 3, icon: <Heart size={28} />, end: "10000", suffix: "+", label: "Başarılı Operasyon", color: "#F06292" },
  ];

  return (
    <section className="stats-wrapper">
      <div className="stats-grid">
        {stats.map((stat) => (
          <div key={stat.id} className="stat-box" style={{ "--item-clr": stat.color }}>
            <div className="stat-icon-mini">{stat.icon}</div>
            <div className="stat-number-wrap">
              <Counter end={stat.end} />
              <span className="stat-suffix">{stat.suffix}</span>
            </div>
            <p className="stat-text">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;